
import Vue from 'vue'

export default Vue.extend({
    props: {
        value: String
    },
    data: () => {
        return {
            copied: false
        }
    },
    methods: {
        async copy() {
            const value = this.value
            if (value) {
                try {
                    await this.$copyText(value)
                    this.copied = true
                    setTimeout(() => { this.copied = false }, 2000)
                    // tslint:disable-next-line:no-empty
                } catch (err) {
                }
            }
        }
    }
})
